import React, { Component } from 'react';

export default class ShareBlock extends Component {

    constructor(props) {
        super(props);
    }

    reset = () => {
        this.props.resetHandle();
    };

    share = () => {
        this.props.shareHandle();
    };

    print = () => {
        this.props.printHandle();
    };

    save = () => {
        this.props.saveHandle();
    };

    render() {
        return (
            <div className="share">
                <div className="shareBlock">
                    <ul>
                        {app ?
                            <li onClick={this.save} className="save"><span>Gem resultat</span></li>
                            :
                            <li onClick={this.print} className="print"><span>Print resultat</span></li>
                        }
                        <li onClick={this.share} className="share"><span>Del resultat</span></li>
                        <li onClick={this.reset} className="reset"><span>Start forfra</span></li>
                    </ul>
                </div>
                <div className="help">
                    Har du spørgsmål til resultatet? <a href="mailto:fristberegneren@poulschmith.dk">Klik her.</a>
                </div>
                <div className="terms">
                    <strong>BEMÆRK:</strong> Ved at bruge Fristberegneren, accepterer du disse <a href="/terms">Vilkår og betingelser</a>, herunder at brugen af Fristberegneren fuldt ud sker på eget ansvar, og at Udvikleren således ikke påtager sig ansvar for fejl eller mangler af nogen som helst art.
                </div>
            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ShareBlock.js